import { StopType } from '@/entities/schedules/models/StopType'
import { AlertGridCellValueType } from '@/shared/components/GridTable/GridCells/AlertGridCell'
import { CustomRowStatusType } from '@/shared/components/GridTable/models/CustomRowStatusType'
import { GenericGridRowProps } from '@/shared/components/GridTable/models/GenericGridRowProps'
import { GridTableDragType } from '@/shared/components/GridTable/models/GridTableDragType'

export type ShiftStopDetailsRow = GenericGridRowProps & {
  sequence: number
  displayStopType: string
  stopType: StopType
  isJob?: boolean
  isDepot?: boolean
  isPickup?: boolean
  orderType?: string
  plannedTime: string
  etaTime: string
  adtTime?: string,
  timeAtStop: string
  transitDistance: number
  transitTime: string
  customStatus?: CustomRowStatusType //Custom row color
}

export type ShiftOrderDetailsRow = {
  orderId: string | number
  orderNumber: string
  preferredDateOfOperation: string
  weight: number
  volume: number
  orderQuantity: number
  timeWindow: string
  serviceTime: number
  priority: string
  maxOnboardTime: string
  tripNumber: string
  consignmentNumber: string
  description: string
  deliveryInstruction: string
  comment: string
  stopCompartment?: string
  statusType: string
  statusCellStyle?: {
    backgroundColor?: string
    color?: string
  }
}

export type ShiftAddressDetailsRow = {
  isGeocoded: boolean
  geocodeError?: AlertGridCellValueType
  customerAddress: string
  customerSuburb: string
  customerState: string
  customerPostcode: string
  customerMapRef: string
  customerAdditional: string
  customerDisplayAddress: string
  customerLongitude?: number
  customerLatitude?: number
}

export type ShiftCustomerDetailsRow = {
  customerNumber: string
  customerName: string
}

export type ShiftDepotDetailsRow = {
  depotCode: string
  depotName: string
  depotDisplayAddress: string
  depotLongitude: number
  depotLatitude: number
}

export type ShiftRunningTotalRow = {
  runningWeight: number
  runningVolume: number
  runningQuantity: number
  runningDistance: number
  runningWorkingTime: string
}

// Default objects for initialization
export const defaultStopDetailsRow: ShiftStopDetailsRow = {
  sequence: 0,
  stopType: 1,
  displayStopType: '',
  plannedTime: '00:00',
  etaTime: '00:00',
  timeAtStop: '00:00',
  transitDistance: 0,
  transitTime: '00:00',
  isDraggable: false,
  isDroppable: false,
  isSelectable: false,
  hasHotAction: false,
  hasActions: false,
  textHighlight: false,
  dragType: GridTableDragType.SHIFT_STOP_ROW,
  acceptDropTypes: [GridTableDragType.SHIFT_STOP_ROW, GridTableDragType.UNASSIGNED_ORDER_ROW, GridTableDragType.INBOX_ORDER_ROW],
}

export const defaultOrderDetailsRow: ShiftOrderDetailsRow = {
  orderId: '',
  orderNumber: '',
  preferredDateOfOperation: 'YYYY-MM-DD',
  weight: 0,
  volume: 0,
  orderQuantity: 0,
  timeWindow: '00:00-00:00',
  serviceTime: 0,
  priority: '0',
  maxOnboardTime: '00:00',
  tripNumber: '',
  consignmentNumber: '',
  description: '',
  deliveryInstruction: '',
  comment: '',
  statusType: '',
}

export const defaultAddressDetailsRow: ShiftAddressDetailsRow = {
  isGeocoded: false,
  customerAddress: '',
  customerSuburb: '',
  customerState: '',
  customerPostcode: '',
  customerMapRef: '',
  customerAdditional: '',
  customerDisplayAddress: '',
  customerLatitude: 0,
  customerLongitude: 0,
}

export const defaultCustomerDetailsRow: ShiftCustomerDetailsRow = {
  customerNumber: '',
  customerName: '',
}

export const defaultDepotDetailsRow: ShiftDepotDetailsRow = {
  depotLatitude: 0,
  depotLongitude: 0,
  depotCode: '',
  depotName: '',
  depotDisplayAddress: '',
}

export const defaultRunningTotalRow: ShiftRunningTotalRow = {
  runningWeight: 0,
  runningVolume: 0,
  runningQuantity: 0,
  runningDistance: 0,
  runningWorkingTime: '00:00',
}
